import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CwpNgFrameworkModule } from '@blk/cwp-ng-framework';
import { AnalyticsModule } from '@ddt-web/analytics';
import { GenericDirectivesModule } from '@ddt-web/generic-utils';

import { DisclosureComponent } from './disclosure.component';
import { TpmDisclosureComponent } from './tpm-disclosure.component';

@NgModule({
	declarations: [DisclosureComponent, TpmDisclosureComponent],
	imports: [
		CommonModule,
		AnalyticsModule,
		CwpNgFrameworkModule,
		GenericDirectivesModule
	],
	exports: [DisclosureComponent, TpmDisclosureComponent]
})
export class DisclosureModule { }
